(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-categories"]) return;
  try {
    
  function resetFaqState() {
    $('.faq-item').removeClass('active').show();
    $('.faq-item-title').attr('aria-expanded', 'false');
    $('.faq-item-text').hide().attr('hidden', true);
  }

  function showFaqCat(button, skipScroll) {
    var cats = ($(button).data('cats') || 'all').toString().split(',');
    $('.faq-cat-button').removeClass('active');
    $(button).addClass('active');
    resetFaqState();
    $('.faq-item').hide();

    if(!skipScroll) {
      $('html, body').animate({
        scrollTop: $('.faq-list-box').offset().top - 24
      }, 400);
    }

    var showAll = cats.map(function(cat) { return cat.trim(); }).includes('all');

    $('.faq-item').each(function() {
      var itemCats = ($(this).data('cats') || '').toString().split(',').map(function(cat) { return cat.trim(); });
      if (showAll || cats.some(function(cat) { return itemCats.includes(cat.trim()); })) {
        $(this).show();
      }
    });
  }

  $('.faq-cat-button').on('click', function() {
    showFaqCat($(this));
  });

  showFaqCat($('.faq-cat-button').first(), true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-list"]) return;
  try {
    
  $('.faq-item-title').on('click', function () {
    var $item = $(this).closest('.faq-item');
    var $content = $item.find('.faq-item-text');
    var isOpen = $item.hasClass('active');

    if (isOpen) {
      $content.slideUp(250, function () {
        $content.attr('hidden', true);
      });
    } else {
      $content.attr('hidden', false).slideDown(250);
    }

    $item.toggleClass('active');
    $(this).attr('aria-expanded', !isOpen);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inner-gem-picker"]) return;
  try {
    
  $('.color-button').on('click', function() {
    
    var color = $(this).data("color");
    $(".color-button.active").removeClass("active");
    $(this).addClass('active');
    $(".gems-box img.active").removeClass("active").fadeOut(400);
    $("img."+color+"-pic").addClass("active").fadeIn(400);
    console.log(color)
  })
  

  } catch(e) { console.error(e); }
})();
})();
